<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-popup
      v-if="!isMobile()"
      :title="
        Object.entries(data).length === 0
          ? $t('AddNew') + ' ' + $t('Company')
          : $t('UPDATE') + ' ' + $t('Company')
      "
      button-cancel="border"
      :active.sync="isSidebarActiveLocal"
      classContent="popup-example"
      fullscreen
    >
      <b-modal
        hide-footer
        @hide="clearFields"
        ref="modal-primary"
        id="modal-primary"
        @cancel="clearFields"
        @close="clearFields"
        size="xl"
        modal-class="modal-primary"
        centered
        :title="$t('AddNewDepotSupplier')"
      >
        <b-row>
          <b-col>
            <b-row>
              <b-col cols="9" style="padding-right: 0px">
                <v-select
                  color="danger"
                  v-model="selectedUsingDepot"
                  :options="usingDepotList"
                  size="small"
                  class="mb-2"
                  label="DepotName"
                  autocomplete
                  ref="selectElement"
                  name="user_IsActive"
                >
                </v-select>
              </b-col>
              <b-col style="padding: 0px">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="submitUsingDepot()"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="9">
            <div class="ag-grid-container">
              <ag-grid-vue
                style="width: 100%; height: 300px"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefsDepot"
                :rowData="allowDepotList"
                :localeText="localeText"
                rowSelection="single"
                :suppressCopyRowsToClipboard="true"
                @grid-ready="onGridReady"
              >
              </ag-grid-vue>
            </div>
          </b-col>
        </b-row>
      </b-modal>

      <b-row>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndexLogo">
              <b-tab :title="$t('CompanyLogo')" active>
                <component
                  :is="scrollbarTag"
                  ref="scroll"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <template>
                          <!-- Image Container -->
                          <div
                            class="img-container w-64 mx-auto flex items-center justify-center"
                            v-if="companyLogo"
                          >
                            <img :src="companyLogo" alt="img" class="responsive" />
                          </div>

                          <!-- Image upload Buttons -->
                          <div class="modify-img flex justify-between mt-5">
                            <input
                              type="file"
                              class="hidden"
                              ref="updateImgInput"
                              @change="updateCurrImg"
                              accept="image/*"
                            />
                            <b-button
                              class="bg-success"
                              style="border-color: white"
                              v-on:click="$refs.updateImgInput.click()"
                            >
                              <Icon
                                icon="material-symbols:add-a-photo"
                                style="margin-right: 5px"
                                width="20"
                                height="20"
                              />
                              {{ $t("Upload") }}
                            </b-button>
                            <b-button
                              class="bg-danger"
                              style="border-color: white"
                              v-on:click="companyLogo = null"
                            >
                              <Icon
                                icon="material-symbols:no-photography-outline"
                                style="margin-right: 5px"
                                width="20"
                                height="20"
                              />
                              {{ $t("Delete") }}
                            </b-button>
                          </div>
                        </template>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('CompanySignLogo')">
                <component
                  :is="scrollbarTag"
                  ref="scroll"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <template>
                          <!-- Image Container -->
                          <div
                            class="img-container w-64 mx-auto flex items-center justify-center"
                            v-if="companySignLogo"
                          >
                            <img :src="companySignLogo" alt="img" class="responsive" />
                          </div>

                          <!-- Image upload Buttons -->
                          <div class="modify-img flex justify-between mt-5">
                            <input
                              type="file"
                              class="hidden"
                              ref="updateCurrImgSign"
                              @change="updateCurrImgSign"
                              accept="image/*"
                            />
                            <b-button
                              class="bg-success"
                              style="border-color: white"
                              v-on:click="$refs.updateCurrImgSign.click()"
                            >
                              <Icon
                                icon="material-symbols:add-a-photo"
                                style="margin-right: 5px"
                                width="20"
                                height="20"
                              />
                              {{ $t("Upload") }}
                            </b-button>
                            <b-button
                              class="bg-danger"
                              style="border-color: white"
                              v-on:click="companySignLogo = null"
                            >
                              <Icon
                                icon="material-symbols:no-photography-outline"
                                style="margin-right: 5px"
                                width="20"
                                height="20"
                              />
                              {{ $t("Delete") }}
                            </b-button>
                          </div>
                        </template>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
            </b-tabs>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndex">
              <b-tab :title="$t('General')" active>
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('CompanyName')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="companyName"
                              type="text"
                              class="w-full"
                              name="companyName"
                              v-validate="'required'"
                            />
                            <span
                              class="text-danger text-sm"
                              v-show="errors.has('companyName')"
                              >{{ errors.first("companyName") }}</span
                            >
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('CompanyName') + '2'"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="companyName2"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('CompanyNo')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="companyNo"
                              type="text"
                              class="w-full"
                              v-validate="'required'"
                              name="CompanyNo"
                            />
                            <span
                              class="text-danger text-sm"
                              v-show="errors.has('CompanyNo')"
                              >{{ errors.first("CompanyNo") }}</span
                            >
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="$t('Status')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <v-select
                              color="danger"
                              v-model="status"
                              :options="status_choices"
                              size="small"
                              label="text"
                              autocomplete
                              ref="selectElement"
                              name="user_IsActive"
                            >
                            </v-select>
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('DropShiping')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <b-row align-v="center">
                              <b-col cols="3">
                                <vs-switch
                                  style="border-radius: 20px"
                                  v-model="dropShiping"
                                  v-validate="'required'"
                                  @input="
                                    Object.entries(data).length === 0 ? '' : submitData()
                                  "
                                  name="DropShiping"
                                />

                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('DropShiping')"
                                  >{{ errors.first("DropShiping") }}</span
                                >
                              </b-col>
                              <b-col v-if="dropShiping == true">
                                <b-button
                                  v-on:click="getDepots()"
                                  size="sm"
                                  variant="outline-light"
                                >
                                  <Icon
                                    icon="icon-park-outline:view-grid-detail"
                                    width="30"
                                    height="30"
                                    v-b-tooltip.hover.bottom="$t('AddNew')"
                                    color="#FF9F43"
                                  />
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('eArchiveClientKey')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="eArchiveClientKey"
                              type="text"
                              class="w-full"
                              v-validate="'required'"
                              name="eArchiveClientKey"
                            />
                            
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="'* ' + $t('eArchiveClientId')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="eArchiveClientId"
                              type="text"
                              class="w-full"
                              v-validate="'required'"
                              name="eArchiveClientId"
                            />
                            
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="$t('Description')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-textarea v-model="description" />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Special')">
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <b-row>
                          <b-col>
                            <b-form-group
                              :label="$t('StartDate')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                              <b-form-datepicker
                                id="baslangic"
                                v-model="startDate"
                                size="md"
                                :locale="locale"
                                class="mb-2"
                                today-variant="danger"
                                placeholder="-"
                                :start-weekday="weekday"
                                :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group
                              :label="$t('FinishDate')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                              <b-form-datepicker
                                id="baslangic"
                                v-model="finishDate"
                                size="md"
                                :locale="locale"
                                class="mb-2"
                                today-variant="danger"
                                placeholder="-"
                                :start-weekday="weekday"
                                :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group
                              :label="$t('CancelDate')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                              <b-form-datepicker
                                id="baslangic"
                                v-model="chanelDate"
                                size="md"
                                :locale="locale"
                                class="mb-2"
                                today-variant="danger"
                                placeholder="-"
                                :start-weekday="weekday"
                                :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="$t('GroupCode')"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="groupCode"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="$t('SpecCode') + '1'"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="specCode1"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              class="label-cs"
                              :label="$t('SpecCode') + '2'"
                              label-for="h-first-name"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="specCode2"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Tax')">
                <component
                  :is="scrollbarTag"
                  ref="scroll1"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('TaxOffice')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            ></b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="taxOffice"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('TaxOfficeCode')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="taxOfficeCode"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('TaxNo')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="taxNo"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('TaxCity')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="taxCity"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
            </b-tabs>
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <b-tabs content-class="mt-3" v-model="tabIndexCon">
              <b-tab :title="$t('Contact')" active>
                <component
                  :is="scrollbarTag"
                  ref="scroll2"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('ContactName')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="contactName"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('PhoneAreaCode')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="phohneAreaCode"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Phone') + '1'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="phone1"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Phone') + '2'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="phone2"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="'FAX'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="fax"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="'GSM'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="gsm"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="'EMAIL'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="email"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="'WEB'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="web"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
              <b-tab :title="$t('Address')">
                <component
                  :is="scrollbarTag"
                  ref="scroll2"
                  class="scroll-area--data-list-add-new"
                  :settings="settings"
                  :key="$vs.rtl"
                >
                  <div class="p-6">
                    <b-row>
                      <b-col>
                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('CurrCode')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="currCode"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Address') + '1'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="address1"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Address') + '2'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="address2"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Address') + '3'"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="address3"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('City')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="city"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Country')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="country"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('Town')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="town"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>

                        <b-row style="margin-top: 8px">
                          <b-col cols="4" align-self="center">
                            <b-form-group
                              :label="$t('PostCode')"
                              class="label-cs vs-input--label"
                              style="padding-left: 0px !important"
                            >
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <vs-input
                              size="small"
                              v-model="postCode"
                              type="text"
                              class="w-full"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- Product Image -->
                    <vs-divider></vs-divider>
                  </div>
                </component>
              </b-tab>
              <!--			<b-tab :title="$t('Note')" active>
							<component :is="scrollbarTag" ref="scroll2" class="scroll-area--data-list-add-new" :settings="settings"
								:key="$vs.rtl">
								<div class="p-6">
									<b-row>
										<b-col>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('ContactName')" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="contactName" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('PhoneAreaCode')" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phohneAreaCode" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('Phone') + '1'" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phone1" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('Phone') + '2'" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phone2" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'FAX'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="fax" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'GSM'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="gsm" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'EMAIL'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="email" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'WEB'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="web" type="text" class="w-full" />
												</b-col>
											</b-row>


										</b-col>

									</b-row> 
									<vs-divider></vs-divider>
								</div>
							</component>
						</b-tab>-->
            </b-tabs>
          </vs-card>
        </b-col>
      </b-row>

      <div class="items-center pl-6 mt-0 mb-0">
        <b-row align-h="end">
          <b-col cols="3" md="auto" style="padding: 0px">
            <b-button
              class="bg-danger"
              style="border-color: white"
              v-on:click="isSidebarActiveLocal = false"
            >
              <Icon
                icon="material-symbols:cancel-outline"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("Cancel") }}
            </b-button>
          </b-col>
          <b-col cols="3" md="auto">
            <b-button
              class="bg-primary"
              style="border-color: white"
              v-on:click="submitData()"
            >
              <Icon
                icon="material-symbols:save-outline"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
    <vs-sidebar
      v-else
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>
          {{ Object.entries(this.data).length === 0 ? $t("AddNew") : $t("UPDATE") }}
        </h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new-mobile2"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <!-- Product Image -->
          <template>
            <h5 class="text-primary">{{ $t("CompanyLogo") }}</h5>
            <!-- Image Container -->
            <div
              class="img-container w-64 mx-auto flex items-center justify-center"
              v-if="companyLogo"
            >
              <img :src="companyLogo" alt="img" class="responsive" />
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input
                type="file"
                class="hidden"
                ref="updateImgInput"
                @change="updateCurrImg"
                accept="image/*"
              />
              <b-button
                class="bg-success"
                style="border-color: white"
                v-on:click="$refs.updateImgInput.click()"
              >
                <Icon
                  icon="material-symbols:add-a-photo"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Upload") }}
              </b-button>
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="companyLogo = null"
              >
                <Icon
                  icon="material-symbols:no-photography-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />
                {{ $t("Delete") }}
              </b-button>
            </div>
          </template>
          <vs-divider></vs-divider>
          <template>
            <h5 class="text-primary">{{ $t("CompanySignLogo") }}</h5>
            <!-- Image Container -->
            <div
              class="img-container w-64 mx-auto flex items-center justify-center"
              v-if="companySignLogo"
            >
              <img :src="companySignLogo" alt="img" class="responsive" />
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input
                type="file"
                class="hidden"
                ref="updateCurrImgSign"
                @change="updateCurrImgSign"
                accept="image/*"
              />
              <b-button
                class="bg-success"
                style="border-color: white"
                v-on:click="$refs.updateCurrImgSign.click()"
              >
                <Icon
                  icon="material-symbols:add-a-photo"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Upload") }}
              </b-button>
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="companySignLogo = null"
              >
                <Icon
                  icon="material-symbols:no-photography-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />
                {{ $t("Delete") }}
              </b-button>
            </div>
          </template>
          <vs-divider></vs-divider>
          <b-tabs content-class="mt-3" v-model="tabIndex">
            <b-tab :title="$t('General')" active>
              <component
                :is="scrollbarTag"
                ref="scroll"
                class="scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="pr-5 pb-5">
                  <b-row>
                    <b-col>
                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('CompanyName')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="companyName"
                            type="text"
                            class="w-full"
                            name="companyName"
                            v-validate="'required'"
                          />
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('companyName')"
                            >{{ errors.first("companyName") }}</span
                          >
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('CompanyName') + '2'"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="companyName2"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('CompanyNo')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="companyNo"
                            type="text"
                            class="w-full"
                            v-validate="'required'"
                            name="CompanyNo"
                          />
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('CompanyNo')"
                            >{{ errors.first("CompanyNo") }}</span
                          >
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="$t('Status')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <v-select
                            color="danger"
                            v-model="status"
                            :options="status_choices"
                            size="small"
                            label="text"
                            autocomplete
                            ref="selectElement"
                            name="user_IsActive"
                          >
                          </v-select>
                        </b-col>
                      </b-row>
                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('DropShiping')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-switch
                            style="border-radius: 20px"
                            v-model="dropShiping"
                            v-validate="'required'"
                            @input="
                              Object.entries(this.data).length === 0 ? '' : submitData()
                            "
                            name="DropShiping"
                          />

                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('DropShiping')"
                            >{{ errors.first("DropShiping") }}</span
                          >
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('eArchiveClientKey')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="eArchiveClientKey"
                            type="text"
                            class="w-full"
                            v-validate="'required'"
                            name="eArchiveClientKey"
                          />
                          
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="'* ' + $t('eArchiveClientId')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="eArchiveClientId"
                            type="text"
                            class="w-full"
                            v-validate="'required'"
                            name="eArchiveClientId"
                          />
                           
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="$t('Description')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-textarea v-model="description" />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </component>
              <vs-divider></vs-divider>
            </b-tab>
            <b-tab :title="$t('Special')">
              <component
                :is="scrollbarTag"
                ref="scroll"
                class="scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="pr-5 pb-5">
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <b-form-group
                            :label="$t('StartDate')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                            <b-form-datepicker
                              id="baslangic"
                              v-model="startDate"
                              size="md"
                              :locale="locale"
                              class="mb-2"
                              today-variant="danger"
                              placeholder="-"
                              :start-weekday="weekday"
                              :date-format-options="{
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric',
                              }"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            :label="$t('FinishDate')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                            <b-form-datepicker
                              id="baslangic"
                              v-model="finishDate"
                              size="md"
                              :locale="locale"
                              class="mb-2"
                              today-variant="danger"
                              placeholder="-"
                              :start-weekday="weekday"
                              :date-format-options="{
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric',
                              }"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            :label="$t('CancelDate')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                            <b-form-datepicker
                              id="baslangic"
                              v-model="chanelDate"
                              size="md"
                              :locale="locale"
                              class="mb-2"
                              today-variant="danger"
                              placeholder="-"
                              :start-weekday="weekday"
                              :date-format-options="{
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric',
                              }"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="$t('GroupCode')"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="groupCode"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="$t('SpecCode') + '1'"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="specCode1"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            class="label-cs"
                            :label="$t('SpecCode') + '2'"
                            label-for="h-first-name"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="specCode2"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </component>
              <vs-divider></vs-divider>
            </b-tab>
            <b-tab :title="$t('Tax')">
              <component
                :is="scrollbarTag"
                ref="scroll"
                class="scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="pr-5 pb-5">
                  <b-row>
                    <b-col>
                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('TaxOffice')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          ></b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="taxOffice"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('TaxOfficeCode')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="taxOfficeCode"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('TaxNo')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="taxNo"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('TaxCity')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="taxCity"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </component>
              <vs-divider></vs-divider>
            </b-tab>
          </b-tabs>
          <vs-divider></vs-divider>
          <b-tabs content-class="mt-3" v-model="tabIndexCon">
            <b-tab :title="$t('Contact')" active>
              <component
                :is="scrollbarTag"
                ref="scroll2"
                class="scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="pr-5 pb-5">
                  <b-row>
                    <b-col>
                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('ContactName')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="contactName"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('PhoneAreaCode')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="phohneAreaCode"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Phone') + '1'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="phone1"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Phone') + '2'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="phone2"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="'FAX'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="fax"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="'GSM'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="gsm"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="'EMAIL'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="email"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="'WEB'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="web"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <vs-divider></vs-divider>
                </div>
              </component>
            </b-tab>
            <b-tab :title="$t('Address')">
              <component
                :is="scrollbarTag"
                ref="scroll2"
                class="scroll-area--data-list-add-new-mobile"
                :settings="settings"
                :key="$vs.rtl"
              >
                <div class="pr-5 pb-5">
                  <b-row>
                    <b-col>
                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('CurrCode')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="currCode"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Address') + '1'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="address1"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Address') + '2'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="address2"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Address') + '3'"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="address3"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('City')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="city"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Country')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="country"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('Town')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="town"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>

                      <b-row style="margin-top: 8px">
                        <b-col cols="4" align-self="center">
                          <b-form-group
                            :label="$t('PostCode')"
                            class="label-cs vs-input--label"
                            style="padding-left: 0px !important"
                          >
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <vs-input
                            size="small"
                            v-model="postCode"
                            type="text"
                            class="w-full"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <vs-divider></vs-divider>
                </div>
              </component>
            </b-tab>
            <!--			<b-tab :title="$t('Note')" active>
							<component :is="scrollbarTag" ref="scroll2" class="scroll-area--data-list-add-new-mobile" :settings="settings"
								:key="$vs.rtl">
								<div class="pr-5 pb-5">
									<b-row>
										<b-col>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('ContactName')" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="contactName" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('PhoneAreaCode')" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phohneAreaCode" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('Phone') + '1'" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phone1" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="$t('Phone') + '2'" class="label-cs vs-input--label"
														style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="phone2" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'FAX'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="fax" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'GSM'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="gsm" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'EMAIL'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="email" type="text" class="w-full" />
												</b-col>
											</b-row>

											<b-row style="margin-top:8px">
												<b-col cols="4" align-self="center">
													<b-form-group  class="label-cs" :label="'WEB'" class="label-cs vs-input--label" style="padding-left: 0px !important">

													</b-form-group>
												</b-col>
												<b-col cols="8">
													<vs-input size="small" v-model="web" type="text" class="w-full" />
												</b-col>
											</b-row>


										</b-col>

									</b-row> 
									<vs-divider></vs-divider>
								</div>
							</component>
						</b-tab>-->
          </b-tabs>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <!--		<vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>-->
        <b-button
          class="bg-primary"
          style="border-color: white"
          v-on:click="submitData()"
        >
          <Icon icon="material-symbols:save-outline" width="20" height="20" />{{
            $t("Save")
          }}
        </b-button>
        <b-button
          class="bg-danger"
          style="border-color: white"
          v-on:click="isSidebarActiveLocal = false"
        >
          <Icon icon="material-symbols:cancel-outline" width="20" height="20" />{{
            $t("Cancel")
          }}
        </b-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    Icon,
    uuid,
    AgGridVue,
    detailBtnCellRenderer,
  },
  data() {
    return {
      selectedUsingDepot: [],
      allowDepotList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columnDefsDepot: [],
      usingDepotList: [],
      popupDepotList: false,
      tabIndexLogo: 0,
      tabIndex: 0,
      tabIndexCon: 0,
      isMobile: function () {
        return isMobile;
      },
      companySignLogo: "",
      companyLogo: "",
      companyId: "",
      companyName: "",
      companyName2: "",
      companyNo: "",
      groupCode: "",
      specCode1: "",
      specCode2: "",
      status: 0,
      chanelDate: "",
      description: "",
      contactName: "",
      phohneAreaCode: "",
      phone1: "",
      phone2: "",
      fax: "",
      gsm: "",
      email: "",
      web: "",
      taxOffice: "",
      taxOfficeCode: "",
      taxNo: "",
      taxCity: "",
      companyName2: "",
      currCode: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      country: "",
      town: "",
      postCode: "",
      startDate: "",
      finishDate: "",
      dropShiping: "",
      eArchiveClientKey: "",
      eArchiveClientId: "",

      locale: "de",
      weekday: 1,
      dataId: null,
      dataName: "",
      dataCategory: null,
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      status_choices: [
        {
          text: this.$t("Active"),
          value: 1,
        },
        {
          text: this.$t("Passive"),
          value: 0,
        },
      ],

      category_choices: [
        { text: "Audio", value: "audio" },
        { text: "Computers", value: "computers" },
        { text: "Fitness", value: "fitness" },
        { text: "Appliance", value: "appliance" },
      ],

      order_status_choices: [
        { text: "Pending", value: "pending" },
        { text: "Canceled", value: "canceled" },
        { text: "Delivered", value: "delivered" },
        { text: "On Hold", value: "on_hold" },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    depotAllow(val) {
      this.allowDepotList = this.depotAllow;
      this.columnDefsDepot = [];
      if (this.allowDepotList.length > 0) {
        let columnList = Object.keys(this.allowDepotList[0]);
        this.columnDefsDepot.push({
          width: 50,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "deleteAllowDepot",
            iconDetail: "material-symbols:delete-outline",
            iconColor: "#fe6d73",
          },
        });
        columnList.forEach((val, index) => {
          if (
            val.toString().includes("Id") == false &&
            val.toString().includes("Date") == false
          )
            this.columnDefsDepot.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
        });
      }
      return val;
    },
    usingDepot(val) {
      return val;
    },
    isSidebarActive(val) {
      this.tabIndexLogo = 0;
      this.tabIndex = 0;
      this.tabIndexCon = 0;
      if (!this.isMobile()) {
        this.$refs.scroll.$el.scrollTop = 0;
        this.$refs.scroll1.$el.scrollTop = 0;
        this.$refs.scroll2.$el.scrollTop = 0;
      }
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        const { category, id, img, name, order_status, price } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.companyLogo =
          this.data.CompanyLogo == null
            ? null
            : "data:image/jpeg;base64," + this.data.CompanyLogo;
        this.companySignLogo =
          this.data.CompanySignLogo == null
            ? null
            : "data:image/jpeg;base64," + this.data.CompanySignLogo;
        this.companyId = this.data.CompanyId;
        this.companyNo = this.data.CompanyNo;
        this.companyNo = this.data.CompanyNo;
        this.companyName = this.data.CompanyName;
        this.groupCode = this.data.GroupCode;
        this.specCode1 = this.data.SpecCode1;
        this.specCode2 = this.data.SpecCode2;
        this.status = [
          {
            text: this.data.Status == 0 ? this.$t("Passive") : this.$t("Active"),
            value: this.data.Status,
          },
        ];

        this.chanelDate = this.data.ChanelDate;
        this.description = this.data.Description;
        this.contactName = this.data.ContactName;
        this.phohneAreaCode = this.data.PhohneAreaCode;
        this.phone1 = this.data.Phone1;
        this.phone2 = this.data.Phone2;
        this.fax = this.data.Fax;
        this.gsm = this.data.Gsm;
        this.email = this.data.Email;
        this.web = this.data.Web;
        this.taxOffice = this.data.TaxOffice;
        this.taxOfficeCode = this.data.TaxOfficeCode;
        this.taxNo = this.data.TaxNo;
        this.taxCity = this.data.TaxCity;
        this.companyName2 = this.data.CompanyName2;
        this.currCode = this.data.CurrCode;
        this.address1 = this.data.Address1;
        this.address2 = this.data.Address2;
        this.address3 = this.data.Address3;
        this.city = this.data.City;
        this.country = this.data.Country;
        this.town = this.data.Town;
        this.postCode = this.data.PostCode;
        this.startDate = this.data.StartDate;
        this.finishDate = this.data.FinishDate;
        this.dropShiping = this.data.DropShiping;
        this.eArchiveClientKey = this.data.EArchiveClientKey;
        this.eArchiveClientId = this.data.EArchiveClientId;
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },

  computed: {
    depotAllow: {
      get() {
        return this.$store.state.storehouse.DepotAllow;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    usingDepot: {
      get() {
        return this.$store.state.storehouse.UsingDepot;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return this.$i18n.locale;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.companyName && this.companyNo > 0;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    deleteAllowDepot(param) {
      this.$store.dispatch("storehouse/deleteDepotAllow", param).then((response) => {
        if (response)
          if (response.data.success == true) {
            this.getDepots();
          } else console.log(response);
      });
    },
    clearFields() {
      this.selectedUsingDepot = "";
    },
    submitUsingDepot() {
      const vs = this.$vs;
      var selectedRows = this.selectedUsingDepot;
      let args = [];
      args.push({
        depotId: selectedRows.DepotId,
        depotName: selectedRows.DepotName,
        depotNo: selectedRows.DepotNo,
        depotCompanyInfoId: selectedRows.DepotCompanyInfoId,
        depotCompanyInfoName: selectedRows.DepotCompanyInfoName,
        depotCompanyId: this.companyId,
        depotCompanyName: selectedRows.DepotCompanyName,
      });
      this.$store
        .dispatch("storehouse/addDepotAllow", args)
        .then((response) => {
          if (response.status == 200) {
            this.getDepots();
            this.selectedUsingDepot = "";
            vs.notify({
              text: response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getDepots() {
      this.popupDepotList = true;
      this.$refs["modal-primary"].show();

      this.$store.dispatch("storehouse/listUsingDepot").then((response) => {
        if (response)
          if (response.success == true) {
            this.usingDepotList = this.usingDepot;
          } else console.log(response);
      });
      this.$store
        .dispatch("storehouse/listDepotAllow", this.companyId)
        .then((response) => {
          if (response)
            if (response.success == true) {
            } else console.log(response);
        });
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    updateCustomer() {
      this.companyNo = "";
      this.companyName = "";
      this.groupCode = "";
      this.specCode1 = "";
      this.specCode2 = "";
      this.status = "";
      this.chanelDate = "";
      this.description = "";
      this.contactName = "";
      this.phohneAreaCode = "";
      this.phone1 = "";
      this.phone2 = "";
      this.fax = "";
      this.gsm = "";
      this.email = "";
      this.web = "";
      this.taxOffice = "";
      this.taxOfficeCode = "";
      this.taxNo = "";
      this.taxCity = "";
      this.companyName2 = "";
      this.currCode = "";
      this.address1 = "";
      this.address2 = "";
      this.address3 = "";
      this.city = "";
      this.country = "";
      this.town = "";
      this.postCode = "";
      this.startDate = "";
      this.finishDate = "";
      this.dropShiping = "";
      this.eArchiveClientKey = "";
      this.eArchiveClientId = "";
    },
    initValues() {
      if (this.data.id) return;
      this.companyId = "";
      this.companyNo = "";
      this.companyName = "";
      this.groupCode = "";
      this.specCode1 = "";
      this.specCode2 = "";
      this.status = "";
      this.chanelDate = "";
      this.description = "";
      this.contactName = "";
      this.phohneAreaCode = "";
      this.phone1 = "";
      this.phone2 = "";
      this.fax = "";
      this.gsm = "";
      this.email = "";
      this.web = "";
      this.taxOffice = "";
      this.taxOfficeCode = "";
      this.taxNo = "";
      this.taxCity = "";
      this.companyName2 = "";
      this.currCode = "";
      this.address1 = "";
      this.address2 = "";
      this.address3 = "";
      this.city = "";
      this.country = "";
      this.town = "";
      this.postCode = "";
      this.startDate = "";
      this.finishDate = "";
      this.dropShiping = "";
      this.eArchiveClientKey = "";
      this.eArchiveClientId = "";
      this.companySignLogo = "";
      this.companyLogo = "";
    },
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let myArray = [];
      if (this.companyLogo != null) myArray = this.companyLogo.split("base64,");
      let myArray2 = [];
      if (this.companySignLogo != null) myArray2 = this.companySignLogo.split("base64,");
      const today = new Date();
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            companyId: this.companyId != "" ? this.companyId : createdId,
            companyNo: this.companyNo,
            companyName: this.companyName,
            groupCode: this.groupCode,
            specCode1: this.specCode1,
            specCode2: this.specCode2,
            status: typeof this.status.value == "undefined" ? 1 : this.status.value,
            companyLogo: this.companyLogo != null ? myArray[1] : this.companyLogo,
            companySignLogo:
              this.companySignLogo != null ? myArray2[1] : this.companySignLogo,
            chanelDate: this.chanelDate == "" ? null : this.chanelDate,
            description: this.description,
            contactName: this.contactName,
            phohneAreaCode: this.phohneAreaCode,
            phone1: this.phone1,
            phone2: this.phone2,
            fax: this.fax,
            gsm: this.gsm,
            email: this.email,
            web: this.web,
            taxOffice: this.taxOffice,
            taxOfficeCode: this.taxOfficeCode,
            taxNo: this.taxNo,
            taxCity: this.taxCity,
            companyName2: this.companyName2,
            currCode: this.currCode,
            address1: this.address1,
            address2: this.address2,
            address3: this.address3,
            city: this.city,
            country: this.country,
            town: this.town,
            postCode: this.postCode,
            startDate: this.startDate == "" ? null : this.startDate,
            finishDate: this.finishDate == "" ? null : this.finishDate,
            advenceSecurity: true,
            partnerFoto: true,
            department: true,
            inbox: "string",
            outBox: "string",
            nace: "string",
            latitude: 0,
            longitude: 0,
            dropShiping: this.dropShiping,
            eArchiveClientKey: this.eArchiveClientKey,
            eArchiveClientId: this.eArchiveClientId,
          };

          if (this.companyId != "") {
            this.$store
              .dispatch("customer/updateCustomer", obj)
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.$root.$emit("getCustomerList");

                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          } else {
            delete obj.id;
            obj.popularity = 0;
            this.$store
              .dispatch("customer/addCustomer", obj)
              .then((response) => {
                if (response.status == 200) {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.$root.$emit("getCustomerList");
                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  vs.notify({
                    text: response.data.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              })
              .catch((error) => {
                return new Promise((resolve, reject) => {
                  resolve(false);
                });
              });
          }
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    updateCurrImgSign(input) {
      const vs = this.$vs;
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();

        if (input.target.files[0].size > 102400)
          vs.notify({
            text: this.$t("ImageSize"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
          });
        else
          reader.onload = (e) => {
            this.companySignLogo = e.target.result;
          };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrImg(input) {
      const vs = this.$vs;
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();

        if (input.target.files[0].size > 102400)
          vs.notify({
            text: this.$t("ImageSize"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right",
          });
        else
          reader.onload = (e) => {
            this.companyLogo = e.target.result;
          };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
  created() {
    this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
    const dict = {
      custom: {
        companyName: {
          required: this.$t("CompanyNameRequired"),
          alpha: this.$t("CompanyNameRequired"),
        },
        CompanyNo: {
          required: this.$t("CompanyNoRequired"),
          alpha: this.$t("CompanyNoRequired"),
        },
      },
    };
    Validator.localize("en", dict);
  },
  mounted() {
    this.$root.$on("deleteAllowDepot", (data) => {
      this.deleteAllowDepot(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("deleteAllowDepot");
  },
};
</script>

<style lang="scss">
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new-mobile2 {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 50px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area--data-list-add-new-mobile {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 500px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.label-cs {
  color: black;
  font-size: small;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

#modal-primary___BV_modal_outer_ {
  z-index: 520100 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
